module.exports = __webpack_public_path__ + "static/media/user_account.568a3652.svg";